module.exports = __webpack_public_path__ + "img/cg2.f9c03ac5.jpg";